import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useProfileUiStore } from '../../store/profileUiStore';

/**
 * `/me` — **내 프로필 화면은 없앴다** (2026-09-07 사용자 지시).
 *
 * 그 화면의 다섯 탭(내 정보 · 내 알림 · 화면·외관 · 캘린더 테마 · 보안)은 넷이 이미
 * **설정 모달**에 그대로 있었고(내 정보 관리 > 프로필 · 환경설정 · 보안설정),
 * 하나만 없었다 — **내 알림**. 그것을 설정 > 알림설정 > 내 알림으로 옮기고 화면을 걷어냈다.
 * 같은 것을 두 자리에 두면 한쪽만 고쳐지는 날이 온다.
 *
 * ★ **주소는 살려 둔다.** 메뉴 레지스트리(`admin_menu_registry`)의 `menu_key='settings'` 행이
 *   운영 DB 에서 `url='/me'` 를 가리키고 있어(admin/backend `menu-registry.ts`), 라우트를
 *   지우면 **레일의 「내 프로필」 메뉴가 404 로 떨어진다**. 레지스트리를 고치려면 서버·DB 가
 *   함께 움직여야 하는데, 이 판은 프론트 단독이다 — 그래서 주소를 받아 **설정을 열고**
 *   대시보드로 보낸다. 북마크·옛 링크도 같은 길로 산다.
 *
 * 딥링크 — 옛 `/me?tab=notifications`(알림 팝업의 '전체 보기' 자리)는 곧바로
 * **설정 > 내 알림**으로 간다. 그 자리로 오던 사람이 «어디로 갔지» 를 겪지 않게.
 */
export function MyProfileMoved() {
  const [params] = useSearchParams();
  const openSettings = useProfileUiStore((s) => s.openSettings);
  const tab = params.get('tab');

  useEffect(() => {
    if (tab === 'notifications') openSettings('inbox');
    else openSettings('account', 'profile');
  }, [tab, openSettings]);

  return <Navigate to="/dashboard" replace />;
}
